if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));

        const prevButton = this.querySelector('.product-media-modal__nav--prev');
        const nextButton = this.querySelector('.product-media-modal__nav--next');
        if (prevButton) prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
        if (nextButton) nextButton.addEventListener('click', this.showNextMedia.bind(this));

        // The base ModalDialog closes the modal on any pointerup inside it
        // (its "click anywhere to dismiss" behavior). With explicit prev/close/next
        // controls now in place, that's no longer wanted: only the close button
        // and Escape key should close the modal.
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) dialog.addEventListener('pointerup', (event) => event.stopPropagation());

        this.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'ARROWRIGHT') this.showNextMedia();
          if (event.code.toUpperCase() === 'ARROWLEFT') this.showPreviousMedia();
        });
      }

      hide() {
        super.hide();

        // Release the scroll lock set in show() and restore scroll position.
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, this.scrollPositionBeforeOpen || 0);
      }

      show(opener) {
        // `overflow: hidden` on body (set by the base ModalDialog) doesn't
        // reliably block touch scrolling on iOS Safari. Pin body in place
        // instead so the page truly cannot scroll while the modal is open.
        this.scrollPositionBeforeOpen = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPositionBeforeOpen}px`;
        document.body.style.width = '100%';

        super.show(opener);
        this.showActiveMedia();
      }

      getActiveIndex() {
        return this.mediaItems.findIndex((element) => element.classList.contains('active'));
      }

      showPreviousMedia() {
        const currentIndex = this.getActiveIndex();
        const newIndex = currentIndex <= 0 ? this.mediaItems.length - 1 : currentIndex - 1;
        this.setActiveMedia(this.mediaItems[newIndex]);
      }

      showNextMedia() {
        const currentIndex = this.getActiveIndex();
        const newIndex = currentIndex >= this.mediaItems.length - 1 ? 0 : currentIndex + 1;
        this.setActiveMedia(this.mediaItems[newIndex]);
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        this.setActiveMedia(activeMedia);
      }

      setActiveMedia(activeMedia) {
        if (!activeMedia) return;

        window.pauseAllMedia();

        this.mediaItems.forEach((element) => {
          if (element !== activeMedia) element.classList.remove('active');
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}